export const topXMax = <T>(arr: T[], maxElements: number): T[] => {
  if (arr.length < maxElements) {
    return arr
  }

  return arr.slice(0, maxElements)
}
